// TripFormFields — Presentational form fields (Trip Name; Start Date + Start
// Destination grid; End Date + End Destination grid).
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icons, placeholders, and responsive grid (`isMobile ? '1fr' : '1fr 1fr'`) are
// identical to the source. Shared `inputStyle`/`handleFocus`/`handleBlur` come
// from the co-located `styles.js`.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { MapPin, Calendar } from 'lucide-react';
import { inputStyle, handleFocus, handleBlur } from './styles';

export const TripFormFields = React.memo(function TripFormFields({ formData, isMobile, isCreating, onInputChange }) {
  return (
    <>
      {/* Trip Name */}
      <div style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '8px'
        }}>
          Trip Name *
        </label>
        <input
          type="text"
          name="tripName"
          value={formData.tripName}
          onChange={onInputChange}
          placeholder="e.g., Trip to see New York City"
          disabled={isCreating}
          style={inputStyle}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>

      {/* Start Date and Destination */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: '16px',
        marginBottom: '24px'
      }}>
        <div>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>
            <Calendar size={16} />
            Start Date *
          </label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={onInputChange}
            disabled={isCreating}
            style={inputStyle}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </div>

        <div>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>
            <MapPin size={16} />
            Start Destination *
          </label>
          <input
            type="text"
            name="startDestination"
            value={formData.startDestination}
            onChange={onInputChange}
            placeholder="e.g., Dallas, TX"
            disabled={isCreating}
            style={inputStyle}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </div>
      </div>

      {/* End Date and Destination */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: '16px',
        marginBottom: '30px'
      }}>
        <div>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>
            <Calendar size={16} />
            End Date *
          </label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={onInputChange}
            disabled={isCreating}
            style={inputStyle}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </div>

        <div>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>
            <MapPin size={16} />
            End Destination *
          </label>
          <input
            type="text"
            name="endDestination"
            value={formData.endDestination}
            onChange={onInputChange}
            placeholder="e.g., New York, NY"
            disabled={isCreating}
            style={inputStyle}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </>
  );
});

export default TripFormFields;
